import React from 'react';
import styled, { css } from 'styled-components';

import camaraIcon from 'images/cam.png';
import plusIcon from 'images/txt_plus.png';
import cancelIcon from 'images/cancel_icon_white.png';
import constants from 'utils/constants'

export default function CommunityWriteForm({
    onChangeWriteType, 
    onChangeWriteValue, 
    onChangeImageList,
    onClickDeleteImage,
    onCancelWrite,
    onSubmit, 
    writeType,
    writeValue,
    currImgCapacity, 
    imageList, 
    writeVisible, 
    setWriteVisible, 
    setInitWriteFormState,
    fileInputRef,
    type
}) {
    return(
        <WriteFormWrapper>
            <TagList>
                {writeType === '1' ? (
                    <ActiveTagItem>
                        <ActiveTagText>자유글</ActiveTagText>
                    </ActiveTagItem>
                ) : (
                    <TagItem onClick={onChangeWriteType} data-type={1}>
                        <TagText>자유글</TagText>
                    </TagItem>
                )}
                {writeType === '2' ? (
                    <ActiveTagItem>
                        <ActiveTagText>정보공유</ActiveTagText>
                    </ActiveTagItem>
                ) : (
                    <TagItem onClick={onChangeWriteType} data-type={2}>
                        <TagText>정보공유</TagText>
                    </TagItem>
                )}
                {writeType === '3' ? (
                    <ActiveTagItem>
                        <ActiveTagText>가입인사</ActiveTagText>
                    </ActiveTagItem>
                ) : (
                    <TagItem onClick={onChangeWriteType} data-type={3}>
                        <TagText>가입인사</TagText>
                    </TagItem>
                )}
                {writeType === '4' ? (
                    <ActiveTagItem>
                        <ActiveTagText>후기</ActiveTagText>
                    </ActiveTagItem>
                ) : (
                    <TagItem onClick={onChangeWriteType} data-type={4}>
                        <TagText>후기</TagText>
                    </TagItem>
                )}
            </TagList>
            {writeVisible ? (
                <CommunityForm>
                    <TextArea>
                        <TextInput
                            onChange={onChangeWriteValue}
                            value={writeValue ? writeValue : ''}
                            placeholder={'자유롭게 이야기를 나눠보세요 :)'}
                            row={100}
                        />
                    </TextArea>
                    <ImageList>
                        {imageList.map((image, index) => {
                            let imageUrl = null;
                            if(image['type'] === 'newImage')
                            {
                                imageUrl = URL.createObjectURL(image['data'])
                            }
                            else
                            {
                                if(type === 'campaign')
                                {
                                    imageUrl = `${constants['imagePath']}/campaign_post_img/${image['data']}`;
                                }
                                else if(type === 'group')
                                {
                                    imageUrl = `${constants['imagePath']}/group_post_img/${image['data']}`;
                                }
                            }
                            return (
                                <ImageBlock>
                                    <ImageItem src={imageUrl}/>
                                    <DeleteButton onClick={() => onClickDeleteImage(index)}>
                                        <DeleteIcon src={cancelIcon}/>
                                    </DeleteButton>
                                </ImageBlock>
                            )
                        })}
                    </ImageList>
                    <WriteButtonBlock>
                        <FileInput 
                            type='file' 
                            id='community_img_file'
                            multiple={true}
                            onChange={onChangeImageList}
                            ref={fileInputRef}    
                        />
                        <FileInputLabel htmlFor={'community_img_file'}>
                            <LabelImgBlock>
                                <LabelImg src={camaraIcon}/>
                            </LabelImgBlock>
                            <ImgCount>{currImgCapacity} / 10</ImgCount>
                        </FileInputLabel>
                        <ButtonBlock>
                            <CancelButton onClick={onCancelWrite}>취소</CancelButton>
                            <SubmitButton onClick={onSubmit}>작성</SubmitButton>
                        </ButtonBlock>
                    </WriteButtonBlock>
                </CommunityForm>
            ) : (
                <DisableTextArea onClick={() => setWriteVisible(true)}>
                    <PlusIconBlock>
                        <PlusIcon src={plusIcon}/>
                    </PlusIconBlock>
                    <DisableText>이곳에 글을 쓸 수 있어요 :)</DisableText>
                </DisableTextArea>
            )}
        </WriteFormWrapper>
    )
}

const WriteFormWrapper = styled.div`
    width: clac(100vw * (12 /375));
    border-radius: clac(100vw * (5 / 375));
    border: solid calc(100vw * (1 / 375)) #eaeaea;
    background-color: #ffffff;
    padding: calc(100vw * (12 / 375)) calc(100vw * (16 / 375)) calc(100vw * (24 / 375)) calc(100vw * (15 / 375));
`;

const TagList = styled.ul`
    display: flex;
    justify-content: space-between;
`;

const tagItemStyle = css`
    width: calc(100vw * (74 / 375));
    height: calc(100vw * (26 / 375));
    border-radius: calc(100vw * (5 / 375));
    border: solid calc(100vw * (1 / 375)) #7f7f7f;
`;

const TagItem = styled.li`
    ${tagItemStyle}
`;

const ActiveTagItem = styled.li`
    ${tagItemStyle}
    background-color: #1d1d1d;
`;

const tagTextStyle = css`
    display: block;
    text-align: center;
    font-size: calc(100vw * (12 / 375));
    font-weight: 500;
    line-height: calc(100vw * (24 / 375));
    color: #707070;
`;

const TagText = styled.span`
    ${tagTextStyle}
`;

const ActiveTagText = styled.span`
    ${tagTextStyle}
    color: #fff;
`;

const CommunityForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

const TextArea = styled.div`
    margin-top: calc(100vw * (24 / 375));
    width: 100%;
    overflow-y: hidden;
`;

const TextInput = styled.textarea`
    width: 100%;
    height: calc(100vw * (129 / 375));
    font-size: calc(100vw * (14 / 375));
`;

const ImageList = styled.div`
    display: flex;
    flex-wrap: wrap;

    & > div:nth-child(2n) {
        margin-right: 0;
    }
`;

const ImageBlock = styled.div`
    position: relative;
    width: calc(100vw * (150 / 375));
    height: calc(100vw * (150 / 375));
    margin-right: calc(100vw * (5 / 375));
    margin-bottom: calc(100vw * (5 / 375));
`;

const ImageItem = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`; 

const DeleteButton = styled.div`
    position: absolute;
    top: 17px;
    right: -7px;
    border-radius: 50%;
    width: calc(100vw * (25 / 375));
    height: calc(100vw * (25 / 375));
    padding: 8px;
    background: rgba(0, 0, 0, 0.55);
`;

const DeleteIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const WriteButtonBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const FileInput = styled.input`
    display: none;
`;

const FileInputLabel = styled.label`
    display: block;
    width: calc(100vw * (62 / 375));
    height: calc(100vw * (44 / 375));
    background-color: #f5f5f5;
    padding: calc(100vw * (9 / 375)) 0;
`;

const LabelImgBlock = styled.div`
    width: calc(100vw * (14.3 / 375));
    height: calc(100vw * (11.7 / 375));
    margin: 0 auto;
`;

const LabelImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ImgCount = styled.span`
    text-align: center;
    display: block;
    font-size: calc(100vw * (9 / 375));
    line-height: 1.11;
    letter-spacing: 0.18px;
    color: #7f7f7f;
    margin-top: calc(100vw * (4.8 / 375));
`;

const ButtonBlock = styled.div``;

const buttonStyle = css`
    width: calc(100vw * (59 / 375));
    height: calc(100vw * (26 / 375));
    border-radius: calc(100vw * (2 / 375));
    background-color: #c6c6c6;
    font-size: calc(100vw * (12 / 375));
    font-weight: 500;
    color: #ffffff;
    line-height: calc(100vw * (26 / 375));
`;

const CancelButton = styled.button`
    ${buttonStyle}
`;

const SubmitButton = styled.button`
    ${buttonStyle}
    background-color: #ffcf19;
    color: #4e4e4e;
    margin-left: calc(100vw * (7 / 375));
`;

const DisableTextArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: calc(100vw * (25 / 375));
`;

const PlusIconBlock = styled.span`
    display: block;
    width: calc(100vw * (12 / 375));
    height: calc(100vw * (12 / 375));
    margin-right: calc(100vw * (8 / 375));
`;

const PlusIcon = styled.img``;

const DisableText = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    color: #c6c6c6;
`;